import {Component, h, Prop, Element, Method} from '@stencil/core';
import {NestToastOptions} from "./nest-toast.interfaces";

@Component({
  tag: 'nest-toast',
  styleUrl: 'nest-toast.scss',
  shadow: false,
})
export class NestToast {
  @Element() element!: HTMLNestToastElement

  @Prop() data: NestToastOptions;

  @Method()
  async close(): Promise<void> {
    this.element.remove()
  }

  render() {
    const { title, message } = this.data;
    return (
      <div class="nest-toast">
        <div class="grid gap-1">
          <div class="font-semibold">{title}</div>
          <div class="text-sm opacity-90">{message}</div>

          <nest-icon name='close-circle' onClick={() => this.close()} />
        </div>
      </div>
    );
  }
}
